import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import css from './index.module.scss';

const F: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const [active, setActive] = useState<number>(0);
    const tabs: string[] = [t('F_tab1'), t('F_tab2'), t('F_tab3')];
    const [gap, setGap] = useState<number>(12);
    const [isM, setIsM] = useState<boolean>(false);
    const [swiper, setSwiper] = useState<SwiperClass | null>(null);
    const items: any[] = [
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1754396586089/pic15-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1754396585878/pic15-m.jpg',
            ],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1754315678166/6_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1754315678167/6_2_M.jpg'],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1754315678154/6_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1754315678353/6_3_M.jpg'],
        },
    ];

    const handleClickTab = (tab: string, k: number) => {
        setActive(k);
        swiper?.slideTo(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('F_title'),
            button_name: tab,
            __btn_id1: 'stream-ultra-x-F',
            __btn_id2: tab,
            __btn_type: 'text',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1024 ? 24 : 12);
            setIsM(window.innerWidth < 768);

            const prev: HTMLDivElement | null = document.querySelector('.stream-ultra-x-F .swiper-button-prev');
            const next: HTMLDivElement | null = document.querySelector('.stream-ultra-x-F .swiper-button-next');
            const btnClick = (e: any) => {
                const button_name =
                    e?.target?.classList?.[0] === 'swiper-button-prev'
                        ? 'Left switch'
                        : e?.target?.classList?.[0] === 'swiper-button-next'
                        ? 'Right switch'
                        : '';
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('F_title'),
                    button_name,
                });
            };
            if (prev) {
                prev.addEventListener('click', btnClick);
            }
            if (next) {
                next.addEventListener('click', btnClick);
            }
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-F GtmModuleData-section`}
            id="stream-ultra-x-F"
            data-section-id={'stream-ultra-x-F'}
            data-section-title={t('F_title')}
        >
            <p className="title">{t('F_title')}</p>
            <div className="tabs-box">
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`GtmModuleData-btn-text tab${active === k ? ' active' : ''}`} key={tab} onClick={() => handleClickTab(tab, k)}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
            <Swiper
                className="items"
                modules={[Navigation]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={true}
                onSwiper={setSwiper}
                onSlideChange={(s: SwiperClass) => setActive(s?.realIndex || 0)}
            >
                {items?.map((item: any, k: number) => (
                    <SwiperSlide className={`item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <img src={item.img[isM ? 1 : 0]} loading="lazy" width="100%" height="100%" />
                        </div>
                        <ul className="item-subs">
                            {[1, 2, 3].map((sub: number) => (
                                <li className={`item-sub item-sub-${sub}`} key={`${k}_${sub}`}>
                                    <p className="item-sub-title">{t(`F_item${k + 1}_sub${sub}_title`)}</p>
                                    <p className="item-sub-desc">{t(`F_item${k + 1}_sub${sub}_desc`)}</p>
                                </li>
                            ))}
                        </ul>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default F;
